import Skeleton from "./Skeleton";

export default function UserDashboardSkeleton() {
  return (
    <div className="space-y-6 p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Skeleton className="w-16 h-16 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="w-40 h-4" />
          <Skeleton className="w-24 h-4" />
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b pb-2">
        <Skeleton className="w-20 h-5" />
        <Skeleton className="w-24 h-5" />
        <Skeleton className="w-16 h-5" />
      </div>

      {/* Content Area */}
      <div className="space-y-4">
        <Skeleton className="w-full h-40" />
        <Skeleton className="w-full h-40" />
      </div>
    </div>
  );
}
